var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLegalExpenses = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-legal_expenses"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "legal_expenses",
  clipPath: "url(#clip-legal_expenses)"
}, /*#__PURE__*/React.createElement("g", {
  id: "auction",
  transform: "matrix(-0.921, 0.391, -0.391, -0.921, 28.661, 22.213)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M11.633,27.619l.755-.295c1.576-1.593,3.6-3.229,5.032-4.935a2.195,2.195,0,0,0-2.143-3.623l-.631-.611a1.633,1.633,0,0,0,.858-1.938c-.073-.275-.26-.429-.35-.679L26.813,5.32a3.613,3.613,0,0,0,.755-1.7V2.868a3.869,3.869,0,0,0-.549-1.419A3.446,3.446,0,0,0,24.715.01c-.258.022-.557-.03-.808,0A3.77,3.77,0,0,0,22,.986L12.065,12.442c-.249-.091-.4-.278-.678-.351a1.628,1.628,0,0,0-1.935.859l-.608-.631A2.192,2.192,0,0,0,5.2,10.2c-1.683,1.438-3.26,3.4-4.861,4.945A2.163,2.163,0,0,0,2.673,18.4l6.533,6.544a2.2,2.2,0,0,0,1.781,2.673h.646Zm-.553-1.092a1.1,1.1,0,0,1-.631-1.739l4.765-4.772A1.082,1.082,0,0,1,16.748,21.5l-4.819,4.825A1.085,1.085,0,0,1,11.08,26.528ZM9.733,23.893,3.718,17.832l4.5-4.553,6.1,6.07L9.732,23.892ZM1.874,17.362A1.085,1.085,0,0,1,1.3,15.676l4.848-4.85a1.079,1.079,0,0,1,1.4,1.614l-4.71,4.72a1.166,1.166,0,0,1-.957.2Zm11.9-.161a.437.437,0,0,1-.2-.122l-3.092-3.1a.537.537,0,0,1,.752-.752L14.4,16.406a.533.533,0,0,1-.632.795Zm.588-2.419L12.822,13.2,18.6,6.591l2.4,2.4-6.641,5.793Zm7.484-6.525L19.336,5.746,20,4.919l2.607,2.622c.019.106-.643.624-.77.716ZM23.45,6.846,20.735,4.089c.629-.653,1.181-1.43,1.8-2.084,2.348-2.487,5.23.7,3.367,2.725L23.449,6.845Z",
  transform: "translate(0 0)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("path", {
  id: "Union_2",
  "data-name": "Union 2",
  d: "M.3,10.207a8,8,0,1,1,14.341,2.218,7.8,7.8,0,0,1-6.6,3.56A7.943,7.943,0,0,1,.3,10.207Zm2.12-5.37A6.4,6.4,0,1,0,12.487,3.444,6.4,6.4,0,0,0,2.422,4.837Zm4.817,7.983-.064-.064v-.918A2.344,2.344,0,0,1,5.6,9.619H7.175A.812.812,0,0,0,8.8,9.6a.875.875,0,0,0-.631-.779A2.754,2.754,0,0,1,6.515,8.3a2.413,2.413,0,0,1,.66-4.161V3.217H8.794v.938a2.356,2.356,0,0,1,1.578,2.262H8.794c-.125-1.459-2.2-.707-1.476.433.261.413.667.313,1.067.383a2.392,2.392,0,0,1,.409,4.606v.982ZM8.794,3.217Zm0,0v0Z",
  transform: "translate(15.999 17)",
  fill: "#fff"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLegalExpenses);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_legal_expenses.434cd63349a059584b9a8bd3b1c0ea40.svg";